import { Button } from "../../Button/Button";
import { FileSelector } from "../../FileSelector/FileSelector";
import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { RichTextEditorImageToolOptions } from "./RichTextEditorToolbar";

export type InsertImageProps = {
	options: RichTextEditorImageToolOptions;
	insertImageHandler(file: File): Promise<void>;
	isDisabled?: boolean;
};

export const InsertImage = (props: InsertImageProps): ReactElement => {
	const {
		insertImageHandler,
		options,
		isDisabled = false
	} = props;

	return (
		<FileSelector
			onChange={insertImageHandler}
			contentTypes={options.imageConstraints
					?.supportedImageTypes}
		>
			{(onClick) => (
				<Button
					kind="secondary"
					onClick={onClick}
					trackingId="add-image"
					text={localize("_AddImage")}
					isDisabled={isDisabled}
				/>
			)}
		</FileSelector>
	);
};
InsertImage.displayName = "InsertImage";